import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import classnames from 'classnames'
import queryString from 'query-string'
import { pathNameKeygen, loadTicketRecommendations } from '../../actions'
import BetsList from './BetsList'
import RecommendationsList from './RecommendationsList'
import { smallTableBetsColumns } from '../../settings'
import './Recommendations.css'

import get from 'lodash/get'
import forEach from 'lodash/forEach'

class TicketPage extends React.Component {

  _rowClassName = ({ rowData, index }) => {
    const { numContextEvents } = this.props
    return classnames(
      'table-row', 
      {'table-row--selected': index < numContextEvents}
    )
  }

  onBetClick = index => {
    const { location } = this.props
    const query = queryString.stringify({...location.query, num_context_events: index+1})
    browserHistory.push([location.pathname, query].join('?'))
  }

  render() {
    const { ticketId, numContextEvents } = this.props

    const _loadTicketRecommendations = loadTicketRecommendations(ticketId)

    return (
      <div className="recommendations-page">
        <div className="hbox hbox--vtop">
          <div className="bet-list hbox--flex">
            <h3 className="table-title">
              Ticket bets
            </h3>
            <BetsList 
              {...this.props}
              ordering='event__begin'
              columns={smallTableBetsColumns}
              ticketId={ticketId} 
              onRowClick={this.onBetClick} 
              rowClassName={this._rowClassName} />
          </div>
          <div className="bet-list hbox--flex">
            <h3 className="table-title">
              Ticket recommendations
            </h3>

            <RecommendationsList 
              {...this.props} 
              keygen={pathNameKeygen}
              loadItems={_loadTicketRecommendations} 
              numContextEvents={numContextEvents}/>
          </div>
        </div>
      </div>
    )
  }
}

const calculateHits = function(state, bets, recommendations) {
  if(!bets || !recommendations) { return {} }

  const betEventIds = {}
  forEach(bets.pages, (page, index) => {
    forEach(page.ids, id => {
      betEventIds[state.entities.bets[id].event_id] = true
    })
  })

  const hits = {}
  forEach(recommendations.pages, (page, index) => {
    forEach(page.ids, id => {
      // bet recommendation id is the event id
      if(betEventIds[id]) {
        hits[id] = true
      }
    })
  })

  return { hits, betEventIds }
}

export default connect(
  (state, ownProps) => {
    const { playerId, ticketId } = ownProps.params

    const key = pathNameKeygen({state, ownProps})
    const bets = get(state, ['pagination', 'bets', key])
    const recommendations = get(state, ['pagination', 'betRecommendations', key])

    const { hits } = calculateHits(state, bets, recommendations)

    return {
      playerId,
      ticketId,
      hits,
      player: state.entities.players[playerId],
      location: ownProps.location,
      numContextEvents: get(
        state,
        'routing.locationBeforeTransitions.query.num_context_events', 
        2
      )
    }
  },
  { loadTicketRecommendations }
)(TicketPage)



// WEBPACK FOOTER //
// ./src/components/Players/Ticket.js